<article class="block-team block-team-v2 type--v2 section-outset-y" (fstrInViewport)="initSwiper()" [once]="true">
  <div class="container" *ngIf="block.title">
    <h2
      class="text-max-width h1 splitting splitting--word-in"
      *ngIf="block.title"
      [innerHTML]="block.title | highlight : 'font-display text-primary-gradient'"
      data-split
    ></h2>
  </div>

  <ng-container *ngIf="slides?.length">
    <div class="block-team__slider">
      <div class="row">
        <main class="col-12 block-team-v2__main">
          <div class="block-team-v2__main__wrapper">
            <ul class="container container-size-sm">
              <li *ngFor="let item of slides; let i = index; trackBy: trackByFn" [class.set--active]="i === swiperIndex$()">
                <header class="block-team-v2__content" [class.set--active]="i === swiperIndex$()">
                  <header class="mb-3 block-team-v2__content__header">
                    <h2 class="fs-4 mb-1">{{ item.fullName }}</h2>
                    <strong class="fs-4 fs-display-2 fst-italic fw-bold" *ngIf="item.jobPosition">{{ item.jobPosition }}</strong>
                  </header>
                  <p>{{ item.text }}</p>
                  <aside class="block-team-v2__content__skills mt-4" *ngIf="item.skills">
                    <div class="markdown-content" [innerHTML]="item.skills"></div>
                    <h4 class="display-2 fs-3 block-team-v2__content__skills__title fw-bold">Skills</h4>
                  </aside>
                </header>
              </li>
            </ul>
          </div>
        </main>
        <section class="col-12 block-team-v2__slider">
          @defer {
          <swiper-container init="false" #swiper>
            <swiper-slide *ngFor="let item of slides; let i = index; trackBy: trackByFn">
              <div class="container container-size-sm block-team-v2__team-card" [class.set--active]="i === swiperIndex$()">
                <app-team-card
                  [showBackground]="false"
                  [title]="item.firstName"
                  [active]="i === swiperIndex$()"
                  [image]="item.image"
                  *ngIf="item.image"
                ></app-team-card>
              </div>
            </swiper-slide>
          </swiper-container>
          }
        </section>
        <footer class="block-team-v2__controls">
          <div class="container container-size-sm">
            <button class="button show-case-button" aria-label="Vorige" (click)="slideNext()">
              {{ 'volgende-teamlid-knoptekst' | fromDictionary }}
            </button>
            <button (click)="slideNext()" aria-label="Volgende" class="button button button-icon button--dark mt-md-3">
              <fstr-icon anchor="icon-arrow-right"></fstr-icon>
            </button>
          </div>
        </footer>

        <figure class="block-team__figure block-team-v2__figure">
          <ng-container *ngFor="let item of slides; let i = index; trackBy: trackByFn">
            <div *ngIf="i === swiperIndex$()">
              <span class="block-team__figure__title" [class.set--active]="inviewPort && i === swiperIndex$()">
                <span class="block-team__figure__title__rotate fs-1 fw-bold fst-italic">{{ item.firstName }}</span>
              </span>
            </div>
          </ng-container>
          <app-text-shape
            [cssClasses]="'squiggle'"
            [type]="'standalone'"
            [autoplay]="true"
            shapeColor="secondary"
            shape="squiggle-07"
          ></app-text-shape>
        </figure>
      </div>
    </div>
  </ng-container>
</article>
